{
  "level": "nrx01",
  "source": {
    "spawn": "DERIVED_FROM_TREES_BBOX:nrx01",
    "objects": "AREAS.E3:nrx01.e3",
    "mesh": "TREES.E3:nrx01.e3"
  },
  "spawn_point": {
    "position": [
      919.5252813294876,
      540.0683412773665,
      24.0
    ],
    "facing_rad": 0.0,
    "look_point": [
      919.5252813294876,
      640.0683412773665,
      24.0
    ],
    "forward": [
      0.0,
      1.0,
      0.0
    ],
    "up": [
      0.0,
      0.0,
      1.0
    ],
    "derived": true
  },
  "mesh_point_cloud": {
    "note": "Raw vertex positions from TREES.E3.",
    "bbox_min": [
      521.5,
      -1546.8843994140625,
      0.0
    ],
    "bbox_max": [
      3250.0,
      867.8724365234375,
      455.85638427734375
    ],
    "vertex_count": 258,
    "vertices": [
      [
        2400.0,
        -1546.8843994140625,
        433.001953125
      ],
      [
        3250.0,
        -1128.3780517578125,
        0.0
      ],
      [
        3250.0,
        -1320.0,
        254.0399169921875
      ],
      [
        571.7936401367188,
        -1133.3345947265625,
        96.11871337890625
      ],
      [
        2356.416015625,
        -1161.2073974609375,
        252.5999755859375
      ],
      [
        3250.0,
        -839.021484375,
        0.0
      ],
      [
        3250.0,
        -1194.9100341796875,
        337.29998779296875
      ],
      [
        3250.0,
        -1320.0,
        377.51202392578125
      ],
      [
        2356.415771484375,
        -1161.2073974609375,
        252.5999755859375
      ],
      [
        2400.0,
        -1165.08203125,
        259.4554443359375
      ],
      [
        3250.0,
        -1266.0020751953125,
        404.6788024902344
      ],
      [
        3250.0,
        -1320.0,
        429.22332763671875
      ],
      [
        3250.0,
        -1320.0,
        455.85638427734375
      ],
      [
        563.0513305664062,
        -1081.168212890625,
        78.62640380859375
      ],
      [
        2370.186279296875,
        -1157.6663818359375,
        252.5999755859375
      ],
      [
        2370.186279296875,
        -1157.6663818359375,
        252.5999755859375
      ],
      [
        2400.0,
        -1161.3375244140625,
        257.7533874511719
      ],
      [
        2950.0,
        -222.7935791015625,
        0.0
      ],
      [
        2995.2138671875,
        -680.0,
        150.7133026123047
      ],
      [
        660.0,
        344.507568359375,
        140.0
      ],
      [
        660.0,
        324.5968933105469,
        140.0
      ],
      [
        660.0,
        344.507568359375,
        140.0
      ],
      [
        660.0,
        460.0,
        140.0
      ],
      [
        840.0,
        516.0,
        190.0
      ],
      [
        840.0,
        516.0,
        250.0
      ],
      [
        524.7213745117188,
        510.0,
        140.0
      ],
      [
        620.0,
        510.0,
        140.0
      ],
      [
        1290.0,
        574.7734375,
        210.4532470703125
      ],
      [
        1290.0,
        574.7734375,
        140.0
      ],
      [
        1334.64990234375,
        610.0,
        140.0
      ],
      [
        840.0,
        585.0,
        190.0
      ],
      [
        840.0,
        610.0,
        140.0
      ],
      [
        840.0,
        585.0,
        190.0
      ],
      [
        840.0,
        555.0,
        250.0
      ],
      [
        950.0,
        605.0,
        150.0
      ],
      [
        950.0,
        600.0,
        160.0
      ],
      [
        950.0,
        600.0,
        150.0
      ],
      [
        1060.0,
        605.0,
        150.0
      ],
      [
        1060.0,
        600.0,
        160.0
      ],
      [
        1060.0,
        600.0,
        150.0
      ],
      [
        950.0,
        610.0,
        140.0
      ],
      [
        950.0,
        600.0,
        140.0
      ],
      [
        1060.0,
        610.0,
        140.0
      ],
      [
        1060.0,
        600.0,
        140.0
      ],
      [
        840.0,
        620.0,
        120.0
      ],
      [
        840.0,
        610.0,
        140.0
      ],
      [
        840.0,
        460.0,
        120.0
      ],
      [
        1347.324951171875,
        620.0,
        120.0
      ],
      [
        950.0,
        620.0,
        120.0
      ],
      [
        1060.0,
        620.0,
        120.0
      ],
      [
        620.0,
        510.0,
        120.0
      ],
      [
        630.0,
        460.0,
        80.0
      ],
      [
        650.0,
        460.0,
        80.0
      ],
      [
        650.0,
        460.0,
        60.0
      ],
      [
        660.0,
        460.0,
        80.0
      ],
      [
        658.9999389648438,
        344.5075988769531,
        78.0
      ],
      [
        660.0,
        460.0,
        80.0
      ],
      [
        660.0,
        460.0,
        100.0
      ],
      [
        630.0,
        485.8578186035156,
        80.0
      ],
      [
        650.0,
        505.8578186035156,
        80.0
      ],
      [
        1210.0,
        640.0000610351562,
        80.0
      ],
      [
        1210.0,
        641.0,
        78.0
      ],
      [
        1210.0,
        640.0,
        80.0
      ],
      [
        1265.0,
        650.0,
        60.0
      ],
      [
        1265.0,
        640.0,
        80.0
      ],
      [
        1265.0,
        620.0,
        80.0
      ],
      [
        840.0,
        630.0,
        100.0
      ],
      [
        840.0,
        620.0,
        120.0
      ],
      [
        840.0,
        630.0,
        100.0
      ],
      [
        1265.0,
        620.0,
        120.00006103515625
      ],
      [
        1235.0,
        621.0001220703125,
        118.0
      ],
      [
        1215.0,
        621.0,
        118.0
      ],
      [
        1215.0,
        620.0,
        120.0
      ],
      [
        1215.0,
        621.0,
        118.0
      ],
      [
        660.0,
        501.7156677246094,
        100.0
      ],
      [
        636.8701171875,
        480.0,
        98.0
      ],
      [
        630.0,
        473.1298828125,
        98.0
      ],
      [
        630.0,
        460.0,
        98.0
      ],
      [
        638.2843017578125,
        480.0,
        100.0
      ],
      [
        636.8701171875,
        480.0,
        98.0
      ],
      [
        774.1421508789062,
        630.0,
        100.0
      ],
      [
        630.0,
        480.0,
        98.0
      ],
      [
        630.0,
        480.0,
        100.0
      ],
      [
        630.0,
        480.0,
        98.0
      ],
      [
        775.1422729492188,
        631.0000610351562,
        98.0
      ],
      [
        746.8076171875,
        631.0000610351562,
        98.0
      ],
      [
        745.805419921875,
        630.0,
        100.0
      ],
      [
        746.8076782226562,
        631.0000610351562,
        98.0
      ],
      [
        668.4205322265625,
        576.2783813476562,
        98.0
      ],
      [
        675.4915771484375,
        569.2073364257812,
        98.0
      ],
      [
        668.4205322265625,
        576.2783813476562,
        98.0
      ],
      [
        677.8394165039062,
        562.1814575195312,
        99.9787368774414
      ],
      [
        630.0,
        553.85791015625,
        80.0
      ],
      [
        630.0,
        542.5441284179688,
        80.0
      ],
      [
        630.0,
        542.5441284179688,
        80.0
      ],
      [
        655.8578491210938,
        640.0,
        80.0
      ],
      [
        675.5390625,
        640.0000610351562,
        80.0
      ],
      [
        703.8523559570312,
        640.0,
        80.0
      ],
      [
        732.1422119140625,
        640.0000610351562,
        80.0
      ],
      [
        630.0,
        553.85791015625,
        80.0
      ],
      [
        630.0,
        566.14208984375,
        80.0
      ],
      [
        655.8578491210938,
        640.0,
        80.0
      ],
      [
        630.0,
        614.1421508789062,
        80.0
      ],
      [
        630.0,
        640.0,
        80.0
      ],
      [
        704.85205078125,
        641.0000610351562,
        78.0
      ],
      [
        703.8523559570312,
        640.0,
        80.0
      ],
      [
        630.0,
        566.14208984375,
        80.0
      ],
      [
        630.0,
        566.14208984375,
        78.0
      ],
      [
        687.3342895507812,
        595.192138671875,
        80.0
      ],
      [
        629.7952880859375,
        511.0,
        78.0
      ],
      [
        550.0,
        640.0,
        80.0
      ],
      [
        1360.0,
        640.0,
        160.0
      ],
      [
        1360.0,
        640.0,
        300.0
      ],
      [
        1265.0,
        640.0,
        200.0
      ],
      [
        1265.0,
        640.0,
        80.0000228881836
      ],
      [
        1235.0,
        640.0,
        118.0
      ],
      [
        1215.0,
        640.0,
        118.0
      ],
      [
        1215.0,
        640.0,
        120.0
      ],
      [
        1215.0,
        640.0,
        118.0
      ],
      [
        755.8271484375,
        640.0,
        98.0
      ],
      [
        755.8271484375,
        640.0,
        100.0
      ],
      [
        755.8271484375,
        640.0,
        98.0
      ],
      [
        784.1421508789062,
        640.0,
        98.0
      ],
      [
        775.1421508789062,
        631.0,
        98.0
      ],
      [
        854.0377807617188,
        707.730224609375,
        140.0
      ],
      [
        1014.1600952148438,
        867.8525390625,
        140.0
      ],
      [
        1265.0,
        695.0,
        140.0
      ],
      [
        1265.0,
        645.0,
        140.0
      ],
      [
        1265.0,
        720.0,
        140.0
      ],
      [
        1265.0,
        640.0,
        140.0
      ],
      [
        844.2164916992188,
        680.0,
        100.0
      ],
      [
        842.595703125,
        680.0,
        98.0
      ],
      [
        824.3965454101562,
        660.0,
        98.0
      ],
      [
        842.595703125,
        680.0,
        98.0
      ],
      [
        1265.0,
        680.0,
        130.0
      ],
      [
        1265.0,
        680.0,
        140.0
      ],
      [
        1265.0,
        680.0,
        98.0
      ],
      [
        1265.0,
        680.0,
        140.0
      ],
      [
        1265.0,
        640.0,
        98.0
      ],
      [
        1190.0,
        680.0,
        118.0
      ],
      [
        1170.0,
        680.0,
        118.0
      ],
      [
        1040.0,
        680.0,
        118.0
      ],
      [
        1060.0,
        680.0,
        118.0
      ],
      [
        1235.0,
        680.0,
        118.0
      ],
      [
        1215.0,
        680.0,
        118.0
      ],
      [
        1170.0,
        680.0,
        120.0
      ],
      [
        1170.0,
        680.0,
        118.0
      ],
      [
        1215.0,
        680.0,
        120.0
      ],
      [
        1215.0,
        680.0,
        118.0
      ],
      [
        1040.0,
        680.0,
        118.0
      ],
      [
        1040.0,
        680.0,
        120.0
      ],
      [
        1036.0,
        650.0,
        118.0
      ],
      [
        1265.0,
        680.0,
        60.0
      ],
      [
        1210.0,
        680.0,
        80.0
      ],
      [
        1230.0,
        680.0,
        80.0
      ],
      [
        1210.0,
        680.0,
        78.0
      ],
      [
        1210.0,
        680.0,
        80.0
      ],
      [
        866.4380493164062,
        720.1305541992188,
        118.0
      ],
      [
        866.452880859375,
        720.1453857421875,
        118.0
      ],
      [
        1014.179931640625,
        867.8724365234375,
        118.0
      ],
      [
        866.452880859375,
        720.1453857421875,
        118.0
      ],
      [
        866.4380493164062,
        720.1305541992188,
        120.0
      ],
      [
        866.4380493164062,
        720.1305541992188,
        118.0
      ],
      [
        795.45751953125,
        649.1500244140625,
        98.0
      ],
      [
        786.3074951171875,
        640.0,
        98.0
      ],
      [
        795.45751953125,
        649.1500244140625,
        98.0
      ],
      [
        805.0,
        658.6925048828125,
        98.0
      ],
      [
        806.3074951171875,
        660.0,
        98.0
      ],
      [
        826.3074951171875,
        680.0,
        98.0
      ],
      [
        826.3074951171875,
        680.0,
        100.0
      ],
      [
        826.3074951171875,
        680.0,
        98.0
      ],
      [
        521.5,
        792.0,
        80.0
      ],
      [
        521.5,
        818.0,
        80.0
      ],
      [
        521.5,
        811.6676635742188,
        5.0
      ],
      [
        521.5,
        827.0,
        5.0
      ],
      [
        532.1715698242188,
        792.0,
        65.0
      ],
      [
        532.1715698242188,
        818.0,
        65.0
      ],
      [
        532.1715698242188,
        808.0,
        5.0
      ],
      [
        532.1715698242188,
        827.0,
        5.0
      ],
      [
        531.5999755859375,
        818.0,
        80.0
      ],
      [
        532.1715698242188,
        818.0,
        80.0
      ],
      [
        532.1715698242188,
        818.0,
        71.5
      ],
      [
        532.1715698242188,
        818.0,
        65.0
      ],
      [
        521.5,
        818.0,
        80.0
      ],
      [
        532.1715698242188,
        818.0,
        80.0
      ],
      [
        521.5,
        792.0,
        80.0
      ],
      [
        532.1715698242188,
        792.0,
        65.0
      ],
      [
        532.1715698242188,
        792.0,
        79.10589599609375
      ],
      [
        530.2219848632812,
        792.0,
        80.0
      ],
      [
        530.2219848632812,
        792.0,
        80.0
      ],
      [
        532.1715698242188,
        792.0,
        79.10589599609375
      ],
      [
        532.1715698242188,
        792.0,
        80.0
      ],
      [
        525.2470092773438,
        814.8071899414062,
        68.0
      ],
      [
        525.2470092773438,
        814.8071899414062,
        77.0
      ],
      [
        525.2470092773438,
        814.8071899414062,
        77.0
      ],
      [
        525.2470092773438,
        814.8071899414062,
        68.0
      ],
      [
        760.0,
        696.1694946289062,
        74.85089874267578
      ],
      [
        770.0,
        706.1732788085938,
        69.78568267822266
      ],
      [
        740.0,
        686.0,
        80.0
      ],
      [
        740.0,
        689.9500732421875,
        78.0
      ],
      [
        532.4025268554688,
        792.0,
        80.0
      ],
      [
        532.2655029296875,
        799.7999877929688,
        65.0
      ],
      [
        532.4025268554688,
        792.0,
        65.0
      ],
      [
        557.5,
        799.7999877929688,
        65.0
      ],
      [
        546.4309692382812,
        743.2847290039062,
        80.0
      ],
      [
        574.301513671875,
        735.4141845703125,
        79.0
      ],
      [
        556.4309692382812,
        753.2847290039062,
        80.0
      ],
      [
        557.5,
        792.0,
        79.0
      ],
      [
        557.5,
        792.0,
        80.0
      ],
      [
        548.6265258789062,
        792.0,
        80.0
      ],
      [
        548.6265258789062,
        792.0,
        80.0
      ],
      [
        557.5,
        799.7999877929688,
        79.0
      ],
      [
        557.5,
        799.7999877929688,
        80.0
      ],
      [
        557.5,
        792.0,
        80.0
      ],
      [
        557.5,
        792.0,
        79.0
      ],
      [
        556.4309692382812,
        753.2847290039062,
        80.0
      ],
      [
        546.4309692382812,
        743.2847290039062,
        80.0
      ],
      [
        557.5,
        799.7999877929688,
        65.0
      ],
      [
        548.5,
        799.7999877929688,
        67.5
      ],
      [
        548.800048828125,
        799.7999877929688,
        67.5
      ],
      [
        548.5,
        799.7999877929688,
        67.80000305175781
      ],
      [
        548.800048828125,
        799.7999877929688,
        67.80000305175781
      ],
      [
        548.800048828125,
        799.7999877929688,
        67.80000305175781
      ],
      [
        548.800048828125,
        799.7999877929688,
        67.5
      ],
      [
        548.5,
        799.7999877929688,
        67.5
      ],
      [
        548.5,
        799.7999877929688,
        67.80000305175781
      ],
      [
        548.6400146484375,
        799.7999877929688,
        67.5
      ],
      [
        548.6400146484375,
        799.7999877929688,
        65.0
      ],
      [
        548.6400146484375,
        799.7999877929688,
        65.0
      ],
      [
        548.6400146484375,
        799.7999877929688,
        67.5
      ],
      [
        546.313720703125,
        808.0,
        5.0
      ],
      [
        546.313720703125,
        827.0,
        5.0
      ],
      [
        557.5,
        818.0,
        80.0
      ],
      [
        546.313720703125,
        818.0,
        65.0
      ],
      [
        546.313720703125,
        818.0,
        80.0
      ],
      [
        547.0999755859375,
        818.0,
        80.0
      ],
      [
        546.313720703125,
        818.0,
        71.5
      ],
      [
        557.5,
        818.0,
        80.0
      ],
      [
        546.313720703125,
        818.0,
        65.0
      ],
      [
        546.313720703125,
        818.0,
        80.0
      ],
      [
        553.6470336914062,
        814.8071899414062,
        68.0
      ],
      [
        553.6470336914062,
        814.8071899414062,
        77.0
      ],
      [
        553.6470336914062,
        814.8071899414062,
        77.0
      ],
      [
        553.6470336914062,
        814.8071899414062,
        68.0
      ],
      [
        565.7156982421875,
        724.0,
        84.0
      ],
      [
        560.8578491210938,
        719.1421508789062,
        84.0
      ],
      [
        580.8578491210938,
        739.1421508789062,
        84.0
      ],
      [
        575.7156982421875,
        734.0,
        84.0
      ],
      [
        564.1448364257812,
        745.5708618164062,
        84.0
      ],
      [
        554.1448364257812,
        735.5708618164062,
        84.0
      ],
      [
        565.7156982421875,
        724.0,
        84.0
      ],
      [
        554.1448364257812,
        735.5708618164062,
        84.0
      ],
      [
        575.7156982421875,
        734.0,
        84.0
      ],
      [
        564.1448364257812,
        745.5708618164062,
        84.0
      ],
      [
        595.0,
        725.0,
        84.0
      ],
      [
        580.8578491210938,
        739.1421508789062,
        84.0
      ],
      [
        575.0,
        705.0,
        84.0
      ],
      [
        560.8578491210938,
        719.1421508789062,
        84.0
      ]
    ]
  },
  "sectors": [
    {
      "plane_normal": [
        -0.04072042927145958,
        0.6873272061347961,
        0.7252056002616882
      ],
      "plane_d": 709.023681640625,
      "bbox_min": [
        0.0,
        -2850.0,
        0.0
      ],
      "bbox_max": [
        7550.0,
        950.0,
        2100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0527450367808342,
        0.6877358555793762,
        0.7240422368049622
      ],
      "plane_d": 740.0001220703125,
      "bbox_min": [
        0.0,
        -2850.0,
        0.0
      ],
      "bbox_max": [
        3250.0,
        -839.021484375,
        1852.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.08598994463682175,
        0.7953926920890808,
        0.5999636054039001
      ],
      "plane_d": 1176.970947265625,
      "bbox_min": [
        0.0,
        -2500.0,
        0.0
      ],
      "bbox_max": [
        3250.0,
        -839.021484375,
        1352.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.10580915957689285,
        0.4114800691604614,
        0.9052561521530151
      ],
      "plane_d": 498.47637939453125,
      "bbox_min": [
        650.0,
        -1700.0,
        0.0
      ],
      "bbox_max": [
        3250.0,
        -1128.3780517578125,
        502.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 3250.0,
      "bbox_min": [
        3250.0,
        -1320.0,
        0.0
      ],
      "bbox_max": [
        3250.0,
        -1128.3780517578125,
        254.0399169921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.07845357060432434,
        0.30509722232818604,
        0.9490841627120972
      ],
      "plane_d": 299.4117431640625,
      "bbox_min": [
        571.7936401367188,
        -1600.0,
        0.0
      ],
      "bbox_max": [
        3250.0,
        -839.021484375,
        455.85638427734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 3250.0,
      "bbox_min": [
        3250.0,
        -1320.0,
        0.0
      ],
      "bbox_max": [
        3250.0,
        -839.021484375,
        377.51202392578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 3250.0,
      "bbox_min": [
        3250.0,
        -1320.0,
        337.29998779296875
      ],
      "bbox_max": [
        3250.0,
        -1194.9100341796875,
        429.22332763671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 3250.0,
      "bbox_min": [
        3250.0,
        -1320.0,
        404.6788024902344
      ],
      "bbox_max": [
        3250.0,
        -1266.0020751953125,
        455.85638427734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.07845357060432434,
        0.30509722232818604,
        0.9490841627120972
      ],
      "plane_d": 299.4117431640625,
      "bbox_min": [
        563.0513305664062,
        -1165.08203125,
        78.62640380859375
      ],
      "bbox_max": [
        2400.0,
        -1081.168212890625,
        259.4554443359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.10580915957689285,
        0.4114800691604614,
        0.9052561521530151
      ],
      "plane_d": 498.47637939453125,
      "bbox_min": [
        2356.415771484375,
        -1165.08203125,
        252.5999755859375
      ],
      "bbox_max": [
        2400.0,
        -1157.6663818359375,
        259.4554443359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 3250.0,
      "bbox_min": [
        505.3768005371094,
        -1320.0,
        0.0
      ],
      "bbox_max": [
        3250.0,
        950.0,
        600.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.07845357060432434,
        0.30509722232818604,
        0.9490841627120972
      ],
      "plane_d": 299.4117431640625,
      "bbox_min": [
        505.3768005371094,
        -1161.3375244140625,
        0.0
      ],
      "bbox_max": [
        3115.0,
        950.0,
        550.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9578263759613037,
        0.0,
        0.2873479127883911
      ],
      "plane_d": 2825.587890625,
      "bbox_min": [
        2950.0,
        -680.0,
        0.0
      ],
      "bbox_max": [
        2995.2138671875,
        -222.7935791015625,
        150.7133026123047
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9578263759613037,
        0.0,
        0.2873479127883911
      ],
      "plane_d": 2825.587890625,
      "bbox_min": [
        505.3768005371094,
        -1161.3375244140625,
        0.0
      ],
      "bbox_max": [
        3115.0,
        950.0,
        550.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8944271802902222,
        0.4472135901451111
      ],
      "plane_d": -608.2105102539062,
      "bbox_min": [
        505.3768005371094,
        -1161.3375244140625,
        5.0
      ],
      "bbox_max": [
        2400.0,
        950.0,
        300.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 120.0,
      "bbox_min": [
        514.7213745117188,
        -1161.3375244140625,
        60.0
      ],
      "bbox_max": [
        2400.0,
        650.0,
        257.7533874511719
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 140.0,
      "bbox_min": [
        524.7213745117188,
        -1161.3375244140625,
        120.0
      ],
      "bbox_max": [
        2400.0,
        620.0,
        257.7533874511719
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -516.0,
      "bbox_min": [
        524.7213745117188,
        -1161.3375244140625,
        140.0
      ],
      "bbox_max": [
        2400.0,
        610.0,
        257.7533874511719
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 660.0,
      "bbox_min": [
        524.7213745117188,
        -1161.3375244140625,
        140.0
      ],
      "bbox_max": [
        2400.0,
        516.0,
        257.7533874511719
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 840.0,
      "bbox_min": [
        840.0,
        -1161.3375244140625,
        190.0
      ],
      "bbox_max": [
        2400.0,
        516.0,
        257.7533874511719
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.10580915957689285,
        0.4114800691604614,
        0.9052561521530151
      ],
      "plane_d": 498.47637939453125,
      "bbox_min": [
        2370.186279296875,
        -1161.3375244140625,
        252.5999755859375
      ],
      "bbox_max": [
        2400.0,
        -1150.0,
        257.7533874511719
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -510.0,
      "bbox_min": [
        524.7213745117188,
        510.0,
        140.0
      ],
      "bbox_max": [
        620.0,
        510.0,
        220.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6193914413452148,
        0.7850823402404785,
        0.0
      ],
      "plane_d": 347.7705078125,
      "bbox_min": [
        715.0,
        516.0,
        140.0
      ],
      "bbox_max": [
        1334.64990234375,
        610.0,
        250.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 840.0,
      "bbox_min": [
        715.0,
        516.0,
        140.0
      ],
      "bbox_max": [
        1060.0,
        610.0,
        250.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 150.0,
      "bbox_min": [
        840.0,
        516.0,
        140.0
      ],
      "bbox_max": [
        1060.0,
        610.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 950.0,
      "bbox_min": [
        950.0,
        600.0,
        150.0
      ],
      "bbox_max": [
        1060.0,
        605.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1060.0,
      "bbox_min": [
        1060.0,
        600.0,
        150.0
      ],
      "bbox_max": [
        1060.0,
        605.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 950.0,
      "bbox_min": [
        950.0,
        600.0,
        140.0
      ],
      "bbox_max": [
        1060.0,
        610.0,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1060.0,
      "bbox_min": [
        1060.0,
        600.0,
        140.0
      ],
      "bbox_max": [
        1060.0,
        610.0,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -516.0999755859375,
      "bbox_min": [
        715.0,
        516.0999755859375,
        145.0
      ],
      "bbox_max": [
        775.0,
        516.0999755859375,
        175.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -460.0,
      "bbox_min": [
        524.7213745117188,
        324.5968933105469,
        120.0
      ],
      "bbox_max": [
        1347.324951171875,
        620.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 660.0,
      "bbox_min": [
        660.0,
        324.5968933105469,
        120.0
      ],
      "bbox_max": [
        660.0,
        460.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.6193914413452148,
        0.7850823402404785,
        0.0
      ],
      "plane_d": 347.7705078125,
      "bbox_min": [
        950.0,
        574.7734375,
        120.0
      ],
      "bbox_max": [
        1347.324951171875,
        620.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -510.0,
      "bbox_min": [
        524.7213745117188,
        510.0,
        120.0
      ],
      "bbox_max": [
        620.0,
        510.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 630.0,
      "bbox_min": [
        514.7213745117188,
        324.60308837890625,
        60.0
      ],
      "bbox_max": [
        1265.0,
        650.0,
        120.00006103515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -460.0,
      "bbox_min": [
        630.0,
        324.60308837890625,
        60.0
      ],
      "bbox_max": [
        1265.0,
        650.0,
        120.00006103515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        630.0,
        324.60308837890625,
        60.0
      ],
      "bbox_max": [
        765.0,
        460.0,
        120.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.8944271802902222,
        0.0,
        0.4472135901451111
      ],
      "plane_d": 554.5448608398438,
      "bbox_min": [
        650.0,
        333.51434326171875,
        60.0
      ],
      "bbox_max": [
        660.0,
        460.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -344.5075988769531,
      "bbox_min": [
        658.9999389648438,
        344.507568359375,
        78.0
      ],
      "bbox_max": [
        660.0,
        344.5075988769531,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -344.5075988769531,
      "bbox_min": [
        650.0,
        344.507568359375,
        78.0
      ],
      "bbox_max": [
        660.0,
        344.5075988769531,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 660.0,
      "bbox_min": [
        660.0,
        344.507568359375,
        80.0
      ],
      "bbox_max": [
        660.0,
        460.0,
        120.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.6324553489685059,
        0.6324553489685059,
        0.4472139775753021
      ],
      "plane_d": 55.386383056640625,
      "bbox_min": [
        630.0,
        460.0,
        60.0
      ],
      "bbox_max": [
        1265.0,
        650.0,
        120.00006103515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -79.99999237060547,
      "bbox_min": [
        630.0,
        460.0,
        60.0
      ],
      "bbox_max": [
        1265.0,
        650.0,
        120.00006103515625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1265.0,
      "bbox_min": [
        1265.0,
        620.0,
        60.0
      ],
      "bbox_max": [
        1265.0,
        650.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8944271802902222,
        0.0,
        0.4472135901451111
      ],
      "plane_d": 554.5448608398438,
      "bbox_min": [
        650.0,
        460.0,
        60.0
      ],
      "bbox_max": [
        660.0,
        520.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 840.0,
      "bbox_min": [
        630.0,
        460.0,
        80.0
      ],
      "bbox_max": [
        1265.0,
        640.0,
        120.00006103515625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 1215.0,
      "bbox_min": [
        1215.0,
        599.730224609375,
        118.0
      ],
      "bbox_max": [
        1215.0,
        621.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 660.0,
      "bbox_min": [
        630.0,
        460.0,
        80.0
      ],
      "bbox_max": [
        660.0,
        515.8578491210938,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 98.0,
      "bbox_min": [
        630.0,
        460.0,
        98.0
      ],
      "bbox_max": [
        660.0,
        480.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -480.0,
      "bbox_min": [
        636.8701171875,
        480.0,
        98.0
      ],
      "bbox_max": [
        660.0,
        480.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 101.92391967773438,
      "bbox_min": [
        630.0,
        473.1298828125,
        78.0
      ],
      "bbox_max": [
        784.1421508789062,
        641.0000610351562,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 660.0,
      "bbox_min": [
        630.0,
        473.1298828125,
        80.0
      ],
      "bbox_max": [
        660.0,
        515.8578491210938,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 98.0,
      "bbox_min": [
        630.0,
        473.1298828125,
        98.0
      ],
      "bbox_max": [
        638.2843017578125,
        480.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -480.0,
      "bbox_min": [
        630.0,
        480.0,
        98.0
      ],
      "bbox_max": [
        638.2843017578125,
        480.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 98.0,
      "bbox_min": [
        630.0,
        485.8578186035156,
        78.0
      ],
      "bbox_max": [
        775.1422729492188,
        641.0000610351562,
        100.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.7063384652137756,
        0.7078742384910583,
        0.0
      ],
      "plane_d": 80.83029174804688,
      "bbox_min": [
        658.9852905273438,
        562.1814575195312,
        98.0
      ],
      "bbox_max": [
        746.8076782226562,
        631.0000610351562,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 65.15435791015625,
      "bbox_min": [
        658.9852905273438,
        562.1814575195312,
        98.0
      ],
      "bbox_max": [
        677.8394165039062,
        576.2783813476562,
        100.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7032982110977173,
        0.7108950018882751,
        -0.0
      ],
      "plane_d": -876.375244140625,
      "bbox_min": [
        673.1273803710938,
        562.1814575195312,
        98.0
      ],
      "bbox_max": [
        677.8394165039062,
        566.8431396484375,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7032982110977173,
        0.7108950018882751,
        -0.0
      ],
      "plane_d": -876.375244140625,
      "bbox_min": [
        673.1273803710938,
        562.1814575195312,
        99.9787368774414
      ],
      "bbox_max": [
        677.8394165039062,
        566.8431396484375,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        630.0,
        485.8578186035156,
        78.0
      ],
      "bbox_max": [
        732.1422119140625,
        641.0000610351562,
        98.0
      ],
      "face_count": 9
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 65.15435791015625,
      "bbox_min": [
        687.3342895507812,
        595.192138671875,
        78.0
      ],
      "bbox_max": [
        689.698486328125,
        597.5563354492188,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3629886209964752,
        0.3629886209964752,
        0.8581832647323608
      ],
      "plane_d": -535.9135131835938,
      "bbox_min": [
        666.0563354492188,
        569.2073364257812,
        80.0
      ],
      "bbox_max": [
        696.76953125,
        597.5563354492188,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 65.15435791015625,
      "bbox_min": [
        666.0563354492188,
        573.9141845703125,
        80.0
      ],
      "bbox_max": [
        689.698486328125,
        597.5563354492188,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8944272398948669,
        0.44721361994743347
      ],
      "plane_d": -491.93499755859375,
      "bbox_min": [
        514.7213745117188,
        460.0,
        60.0
      ],
      "bbox_max": [
        630.0,
        640.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 98.0,
      "bbox_min": [
        620.0,
        460.0,
        78.0
      ],
      "bbox_max": [
        630.0,
        511.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -480.0,
      "bbox_min": [
        620.0,
        480.0,
        98.0
      ],
      "bbox_max": [
        630.0,
        480.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9796782732009888,
        -0.20057573914527893,
        0.0
      ],
      "plane_d": 719.490966796875,
      "bbox_min": [
        629.7952880859375,
        510.0,
        78.0
      ],
      "bbox_max": [
        630.0,
        511.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -510.0,
      "bbox_min": [
        524.7213745117188,
        510.0,
        78.0
      ],
      "bbox_max": [
        630.0,
        640.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -79.99999237060547,
      "bbox_min": [
        550.0,
        510.0,
        78.0
      ],
      "bbox_max": [
        630.0,
        640.0,
        80.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -560.0,
      "bbox_min": [
        570.0,
        510.0,
        78.0
      ],
      "bbox_max": [
        630.0,
        566.14208984375,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9796782732009888,
        -0.20057573914527893,
        0.0
      ],
      "plane_d": 719.490966796875,
      "bbox_min": [
        623.85791015625,
        510.0,
        78.0
      ],
      "bbox_max": [
        630.0,
        540.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071071863174438,
        0.707106351852417,
        0.0
      ],
      "plane_d": 45.15484619140625,
      "bbox_min": [
        623.85791015625,
        560.0,
        78.0
      ],
      "bbox_max": [
        630.0,
        566.14208984375,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -640.0,
      "bbox_min": [
        505.3768005371094,
        555.0,
        5.0
      ],
      "bbox_max": [
        1360.0,
        950.0,
        300.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        -0.6193914413452148,
        0.7850823402404785,
        0.0
      ],
      "plane_d": 347.7705078125,
      "bbox_min": [
        745.805419921875,
        555.0,
        80.0
      ],
      "bbox_max": [
        1360.0,
        640.0,
        300.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1360.0,
      "bbox_min": [
        745.805419921875,
        555.0,
        80.0
      ],
      "bbox_max": [
        1360.0,
        640.0,
        300.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 950.0,
      "bbox_min": [
        745.805419921875,
        555.0,
        80.0
      ],
      "bbox_max": [
        1265.0,
        640.0,
        250.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1060.0,
      "bbox_min": [
        1060.0,
        600.0,
        80.0000228881836
      ],
      "bbox_max": [
        1265.0,
        640.0,
        250.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1265.0,
      "bbox_min": [
        1215.0,
        620.0,
        80.0000228881836
      ],
      "bbox_max": [
        1265.0,
        640.0,
        200.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 1215.0,
      "bbox_min": [
        1215.0,
        620.0,
        118.0
      ],
      "bbox_max": [
        1215.0,
        640.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 840.0,
      "bbox_min": [
        745.805419921875,
        555.0,
        80.0
      ],
      "bbox_max": [
        840.0,
        640.0,
        250.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 98.0,
      "bbox_min": [
        745.805419921875,
        630.0,
        80.0
      ],
      "bbox_max": [
        784.1422119140625,
        640.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 101.92391967773438,
      "bbox_min": [
        774.1421508789062,
        630.0,
        98.0
      ],
      "bbox_max": [
        784.1421508789062,
        640.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 101.92391967773438,
      "bbox_min": [
        775.1421508789062,
        631.0,
        80.0
      ],
      "bbox_max": [
        784.1421508789062,
        640.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 140.0,
      "bbox_min": [
        505.3768005371094,
        640.0,
        5.0
      ],
      "bbox_max": [
        1360.0,
        950.0,
        300.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 760.0,
      "bbox_min": [
        760.0,
        640.0,
        140.0
      ],
      "bbox_max": [
        1360.0,
        950.0,
        300.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": 103.45501708984375,
      "bbox_min": [
        854.0377807617188,
        640.0,
        140.0
      ],
      "bbox_max": [
        1360.0,
        867.8525390625,
        300.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1360.0,
      "bbox_min": [
        1265.0,
        640.0,
        140.0
      ],
      "bbox_max": [
        1360.0,
        720.0,
        300.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1265.0,
      "bbox_min": [
        1265.0,
        640.0,
        140.0
      ],
      "bbox_max": [
        1265.0,
        720.0,
        200.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.6343928575515747,
        0.577269971370697,
        0.5141060948371887
      ],
      "plane_d": 91.6107177734375,
      "bbox_min": [
        505.3768005371094,
        640.0,
        5.0
      ],
      "bbox_max": [
        1265.0,
        882.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -680.0,
      "bbox_min": [
        824.3965454101562,
        640.0,
        60.0
      ],
      "bbox_max": [
        1265.0,
        727.730224609375,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 97.99999237060547,
      "bbox_min": [
        824.3965454101562,
        640.0,
        60.0
      ],
      "bbox_max": [
        1265.0,
        680.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1265.0,
      "bbox_min": [
        990.0,
        640.0,
        98.0
      ],
      "bbox_max": [
        1265.0,
        680.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 117.99999237060547,
      "bbox_min": [
        1000.0,
        640.0,
        98.0
      ],
      "bbox_max": [
        1235.0,
        680.0,
        120.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 1170.0,
      "bbox_min": [
        1036.0,
        640.0,
        118.0
      ],
      "bbox_max": [
        1215.0,
        680.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 1215.0,
      "bbox_min": [
        1215.0,
        640.0,
        118.0
      ],
      "bbox_max": [
        1215.0,
        680.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1040.0,
      "bbox_min": [
        1036.0,
        650.0,
        118.0
      ],
      "bbox_max": [
        1040.0,
        680.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9999999403953552,
        0.0
      ],
      "plane_d": -649.9999389648438,
      "bbox_min": [
        1036.0,
        650.0,
        118.0
      ],
      "bbox_max": [
        1040.0,
        650.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9999999403953552,
        0.0
      ],
      "plane_d": -649.9999389648438,
      "bbox_min": [
        1000.0,
        650.0,
        98.0
      ],
      "bbox_max": [
        1040.0,
        650.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 990.0,
      "bbox_min": [
        990.0,
        640.0,
        98.0
      ],
      "bbox_max": [
        990.0,
        660.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1265.0,
      "bbox_min": [
        1210.0,
        640.0,
        60.0
      ],
      "bbox_max": [
        1265.0,
        680.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -79.99999237060547,
      "bbox_min": [
        1210.0,
        640.0,
        78.0
      ],
      "bbox_max": [
        1230.0,
        680.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1210.0,
      "bbox_min": [
        1210.0,
        640.0,
        78.0
      ],
      "bbox_max": [
        1210.0,
        680.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1265.0,
      "bbox_min": [
        1040.0,
        680.0,
        60.0
      ],
      "bbox_max": [
        1265.0,
        727.730224609375,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -79.99999237060547,
      "bbox_min": [
        1040.0,
        680.0,
        78.0
      ],
      "bbox_max": [
        1235.0,
        727.730224609375,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1210.0,
      "bbox_min": [
        1210.0,
        680.0,
        78.0
      ],
      "bbox_max": [
        1210.0,
        717.730224609375,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 118.0,
      "bbox_min": [
        1040.0,
        680.0,
        118.0
      ],
      "bbox_max": [
        1235.0,
        707.730224609375,
        120.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1040.0,
      "bbox_min": [
        1040.0,
        680.0,
        118.0
      ],
      "bbox_max": [
        1215.0,
        707.730224609375,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 1215.0,
      "bbox_min": [
        1170.0,
        680.0,
        118.0
      ],
      "bbox_max": [
        1215.0,
        687.730224609375,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 1170.0,
      "bbox_min": [
        1170.0,
        680.0,
        118.0
      ],
      "bbox_max": [
        1170.0,
        687.730224609375,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": 103.45501708984375,
      "bbox_min": [
        505.3768005371094,
        640.0,
        5.0
      ],
      "bbox_max": [
        1014.2000122070312,
        882.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 118.0,
      "bbox_min": [
        786.3074951171875,
        640.0,
        98.0
      ],
      "bbox_max": [
        1014.2000122070312,
        867.8724365234375,
        120.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        -0.0
      ],
      "plane_d": 1121.87353515625,
      "bbox_min": [
        866.4380493164062,
        720.11572265625,
        118.0
      ],
      "bbox_max": [
        866.452880859375,
        720.1305541992188,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 97.99999237060547,
      "bbox_min": [
        786.3074951171875,
        640.0,
        98.0
      ],
      "bbox_max": [
        844.2164916992188,
        680.0,
        100.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -680.0,
      "bbox_min": [
        826.3074951171875,
        680.0,
        98.0
      ],
      "bbox_max": [
        844.2164916992188,
        680.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 118.0,
      "bbox_min": [
        505.3768005371094,
        640.0,
        5.0
      ],
      "bbox_max": [
        1014.179931640625,
        882.0,
        120.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        -0.0
      ],
      "plane_d": 1121.87353515625,
      "bbox_min": [
        760.0,
        701.7156982421875,
        118.0
      ],
      "bbox_max": [
        866.4380493164062,
        750.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        -0.0
      ],
      "plane_d": 1053.589111328125,
      "bbox_min": [
        760.0,
        701.7156982421875,
        118.0
      ],
      "bbox_max": [
        788.2843017578125,
        730.0,
        120.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -79.99999237060547,
      "bbox_min": [
        505.3768005371094,
        640.0,
        5.0
      ],
      "bbox_max": [
        826.3074951171875,
        827.0,
        100.0
      ],
      "face_count": 10
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -532.1715698242188,
      "bbox_min": [
        505.3768005371094,
        640.0,
        5.0
      ],
      "bbox_max": [
        770.0,
        827.0,
        80.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -521.5,
      "bbox_min": [
        505.3768005371094,
        792.0,
        5.0
      ],
      "bbox_max": [
        532.1715698242188,
        827.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -5.0,
      "bbox_min": [
        505.3768005371094,
        811.6676635742188,
        5.0
      ],
      "bbox_max": [
        521.5,
        827.0,
        5.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -65.0,
      "bbox_min": [
        521.5,
        792.0,
        5.0
      ],
      "bbox_max": [
        532.1715698242188,
        827.0,
        80.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.8542461395263672,
        -0.4931885004043579,
        -0.1644039750099182
      ],
      "plane_d": -50.44390869140625,
      "bbox_min": [
        527.5279541015625,
        809.2772216796875,
        5.0
      ],
      "bbox_max": [
        528.9803466796875,
        813.3082275390625,
        8.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8542198538780212,
        0.4932330548763275,
        -0.16440673172473907
      ],
      "plane_d": -850.7067260742188,
      "bbox_min": [
        527.5279541015625,
        811.2928466796875,
        5.0
      ],
      "bbox_max": [
        528.9803466796875,
        813.3082275390625,
        8.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": 201.31332397460938,
      "bbox_min": [
        525.0999755859375,
        809.7999877929688,
        8.0
      ],
      "bbox_max": [
        528.0999755859375,
        812.7999877929688,
        17.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5547001957893372,
        0.0,
        0.8320503234863281
      ],
      "plane_d": -299.59356689453125,
      "bbox_min": [
        526.5999755859375,
        809.7999877929688,
        8.0
      ],
      "bbox_max": [
        528.0999755859375,
        812.7999877929688,
        9.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 818.0,
      "bbox_min": [
        521.5,
        792.0,
        65.0
      ],
      "bbox_max": [
        532.1715698242188,
        818.0,
        80.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -68.0,
      "bbox_min": [
        522.9725341796875,
        812.784423828125,
        65.0
      ],
      "bbox_max": [
        527.6273193359375,
        816.8154296875,
        77.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8542449474334717,
        -0.4931878447532654,
        -0.16441155970096588
      ],
      "plane_d": 859.776123046875,
      "bbox_min": [
        522.9725341796875,
        812.784423828125,
        65.0
      ],
      "bbox_max": [
        527.6273193359375,
        816.8154296875,
        68.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8542461395263672,
        -0.4931885004043579,
        -0.1644039750099182
      ],
      "plane_d": -37.694122314453125,
      "bbox_min": [
        526.1749267578125,
        812.784423828125,
        65.0
      ],
      "bbox_max": [
        527.6273193359375,
        816.8154296875,
        68.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8542198538780212,
        0.4932330548763275,
        -0.16440673172473907
      ],
      "plane_d": -841.4163818359375,
      "bbox_min": [
        526.1749267578125,
        814.800048828125,
        65.0
      ],
      "bbox_max": [
        527.6273193359375,
        816.8154296875,
        68.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071195244789124,
        0.7070940732955933,
        -0.0
      ],
      "plane_d": -947.5577392578125,
      "bbox_min": [
        523.5146484375,
        813.145263671875,
        68.0
      ],
      "bbox_max": [
        526.9793701171875,
        816.53955078125,
        77.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": -204.74993896484375,
      "bbox_min": [
        523.5146484375,
        813.145263671875,
        68.0
      ],
      "bbox_max": [
        526.9088134765625,
        816.53955078125,
        77.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -3.7876685382798314e-05,
        -0.5156153440475464,
        0.8568202257156372
      ],
      "plane_d": 361.0263366699219,
      "bbox_min": [
        523.5853271484375,
        813.145263671875,
        68.0
      ],
      "bbox_max": [
        526.9088134765625,
        814.80712890625,
        69.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5078026056289673,
        -0.01057465560734272,
        0.861408531665802
      ],
      "plane_d": 215.90093994140625,
      "bbox_min": [
        523.5146484375,
        813.1455078125,
        68.0
      ],
      "bbox_max": [
        525.2470703125,
        816.53955078125,
        69.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": 204.74993896484375,
      "bbox_min": [
        523.5146484375,
        813.145263671875,
        68.0
      ],
      "bbox_max": [
        526.9793701171875,
        816.53955078125,
        77.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.49991968274116516,
        0.8660718202590942
      ],
      "plane_d": -467.0970764160156,
      "bbox_min": [
        523.5146484375,
        814.80712890625,
        68.0
      ],
      "bbox_max": [
        526.9793701171875,
        816.53955078125,
        69.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.507815420627594,
        -0.010555896908044815,
        0.8614012598991394
      ],
      "plane_d": -317.5642395019531,
      "bbox_min": [
        525.2470703125,
        813.145263671875,
        68.0
      ],
      "bbox_max": [
        526.9793701171875,
        816.53955078125,
        69.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -799.7000122070312,
      "bbox_min": [
        529.5,
        799.2000122070312,
        65.0
      ],
      "bbox_max": [
        530.0,
        810.0,
        68.19999694824219
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 529.5,
      "bbox_min": [
        529.5,
        799.2000122070312,
        65.0
      ],
      "bbox_max": [
        530.0,
        799.7000122070312,
        68.19999694824219
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 799.2000122070312,
      "bbox_min": [
        529.5,
        799.2000122070312,
        65.0
      ],
      "bbox_max": [
        530.0,
        799.7000122070312,
        68.19999694824219
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -530.0,
      "bbox_min": [
        529.5,
        799.2000122070312,
        65.0
      ],
      "bbox_max": [
        530.0,
        799.7000122070312,
        68.19999694824219
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -68.19999694824219,
      "bbox_min": [
        529.5,
        799.2000122070312,
        68.19999694824219
      ],
      "bbox_max": [
        530.0,
        799.7000122070312,
        68.19999694824219
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 809.5,
      "bbox_min": [
        529.5,
        799.7000122070312,
        65.0
      ],
      "bbox_max": [
        530.0,
        810.0,
        68.19999694824219
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 529.5,
      "bbox_min": [
        529.5,
        809.5,
        65.0
      ],
      "bbox_max": [
        530.0,
        810.0,
        68.19999694824219
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -810.0,
      "bbox_min": [
        529.5,
        809.5,
        65.0
      ],
      "bbox_max": [
        530.0,
        810.0,
        68.19999694824219
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -530.0,
      "bbox_min": [
        529.5,
        809.5,
        65.0
      ],
      "bbox_max": [
        530.0,
        810.0,
        68.19999694824219
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -68.19999694824219,
      "bbox_min": [
        529.5,
        809.5,
        68.19999694824219
      ],
      "bbox_max": [
        530.0,
        810.0,
        68.19999694824219
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 67.5,
      "bbox_min": [
        529.5999755859375,
        799.7000122070312,
        65.0
      ],
      "bbox_max": [
        529.9000244140625,
        809.5,
        67.80000305175781
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -67.80000305175781,
      "bbox_min": [
        529.5999755859375,
        799.7000122070312,
        67.5
      ],
      "bbox_max": [
        529.9000244140625,
        809.5,
        67.80000305175781
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 529.5999755859375,
      "bbox_min": [
        529.5999755859375,
        799.7000122070312,
        67.5
      ],
      "bbox_max": [
        529.9000244140625,
        809.5,
        67.80000305175781
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -529.9000244140625,
      "bbox_min": [
        529.9000244140625,
        799.7000122070312,
        67.5
      ],
      "bbox_max": [
        529.9000244140625,
        809.5,
        67.80000305175781
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 529.760009765625,
      "bbox_min": [
        529.760009765625,
        799.7000122070312,
        65.0
      ],
      "bbox_max": [
        529.760009765625,
        809.5,
        67.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -799.7999877929688,
      "bbox_min": [
        532.1715698242188,
        640.0,
        5.0
      ],
      "bbox_max": [
        770.0,
        827.0,
        80.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7072440385818481,
        0.7069695591926575,
        0.0
      ],
      "plane_d": 45.334869384765625,
      "bbox_min": [
        532.1715698242188,
        640.0,
        60.0
      ],
      "bbox_max": [
        770.0,
        799.7999877929688,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.45172518491744995,
        0.892157256603241
      ],
      "plane_d": -381.2560729980469,
      "bbox_min": [
        760.0,
        686.0,
        69.78568267822266
      ],
      "bbox_max": [
        770.0,
        706.1732788085938,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.31622788310050964,
        0.31622788310050964,
        0.8944271206855774
      ],
      "plane_d": -121.60807800292969,
      "bbox_min": [
        532.1715698242188,
        676.1616821289062,
        60.0
      ],
      "bbox_max": [
        770.0,
        799.7999877929688,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.45172518491744995,
        0.892157256603241
      ],
      "plane_d": -381.2560729980469,
      "bbox_min": [
        740.0,
        676.1616821289062,
        60.0
      ],
      "bbox_max": [
        770.0,
        725.5,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 740.0,
      "bbox_min": [
        740.0,
        676.1616821289062,
        78.0
      ],
      "bbox_max": [
        740.0,
        689.9500732421875,
        80.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 740.0,
      "bbox_min": [
        740.0,
        686.0,
        78.0
      ],
      "bbox_max": [
        740.0,
        704.1422119140625,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9998459219932556,
        0.017557965591549873,
        0.0
      ],
      "plane_d": -546.2263793945312,
      "bbox_min": [
        532.1715698242188,
        724.0,
        65.0
      ],
      "bbox_max": [
        575.7156982421875,
        799.7999877929688,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -792.0,
      "bbox_min": [
        532.1715698242188,
        792.0,
        65.0
      ],
      "bbox_max": [
        532.4025268554688,
        799.7999877929688,
        80.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -65.0,
      "bbox_min": [
        532.1715698242188,
        792.0,
        65.0
      ],
      "bbox_max": [
        532.4025268554688,
        799.7999877929688,
        65.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -65.0,
      "bbox_min": [
        532.2655029296875,
        724.0,
        65.0
      ],
      "bbox_max": [
        575.7156982421875,
        799.7999877929688,
        80.0
      ],
      "face_count": 7
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": -911.966796875,
      "bbox_min": [
        532.4024658203125,
        724.0,
        65.0
      ],
      "bbox_max": [
        575.7156982421875,
        799.7999877929688,
        80.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 79.0,
      "bbox_min": [
        532.4024658203125,
        734.0,
        65.0
      ],
      "bbox_max": [
        575.7156982421875,
        799.7999877929688,
        80.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        -0.7071067690849304,
        0.0
      ],
      "plane_d": 926.1088256835938,
      "bbox_min": [
        532.4024658203125,
        734.0,
        79.0
      ],
      "bbox_max": [
        575.7156982421875,
        799.7999877929688,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -792.0,
      "bbox_min": [
        532.4024658203125,
        792.0,
        79.0
      ],
      "bbox_max": [
        557.5,
        799.7999877929688,
        80.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 557.5,
      "bbox_min": [
        557.5,
        792.0,
        79.0
      ],
      "bbox_max": [
        557.5,
        799.7999877929688,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.24342486262321472,
        -0.24342486262321472,
        -0.9388762712478638
      ],
      "plane_d": 123.02920532226562,
      "bbox_min": [
        544.5025024414062,
        743.2847290039062,
        79.0
      ],
      "bbox_max": [
        556.4309692382812,
        755.2131958007812,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        -0.7071067690849304,
        0.0
      ],
      "plane_d": 926.1088256835938,
      "bbox_min": [
        532.9449462890625,
        735.4141845703125,
        65.0
      ],
      "bbox_max": [
        574.301513671875,
        799.7999877929688,
        79.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -792.0,
      "bbox_min": [
        546.4081420898438,
        760.8700561523438,
        65.0
      ],
      "bbox_max": [
        557.5,
        799.7999877929688,
        79.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9246396422386169,
        -0.38084322214126587,
        -0.0
      ],
      "plane_d": 796.6697998046875,
      "bbox_min": [
        546.605224609375,
        762.6718139648438,
        65.0
      ],
      "bbox_max": [
        547.4688110351562,
        764.7684936523438,
        79.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 557.5,
      "bbox_min": [
        548.4000244140625,
        792.0,
        65.0
      ],
      "bbox_max": [
        557.5,
        799.7999877929688,
        79.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -548.9000244140625,
      "bbox_min": [
        548.4000244140625,
        799.2000122070312,
        65.0
      ],
      "bbox_max": [
        548.9000244140625,
        799.7000122070312,
        68.19999694824219
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 799.2000122070312,
      "bbox_min": [
        548.4000244140625,
        799.2000122070312,
        65.0
      ],
      "bbox_max": [
        548.9000244140625,
        799.7000122070312,
        68.19999694824219
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 548.4000244140625,
      "bbox_min": [
        548.4000244140625,
        799.2000122070312,
        65.0
      ],
      "bbox_max": [
        548.9000244140625,
        799.7000122070312,
        68.19999694824219
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -68.19999694824219,
      "bbox_min": [
        548.4000244140625,
        799.2000122070312,
        68.19999694824219
      ],
      "bbox_max": [
        548.9000244140625,
        799.7000122070312,
        68.19999694824219
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 67.5,
      "bbox_min": [
        548.5,
        799.7000122070312,
        65.0
      ],
      "bbox_max": [
        548.800048828125,
        799.7999877929688,
        67.80000305175781
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -67.80000305175781,
      "bbox_min": [
        548.5,
        799.7000122070312,
        67.5
      ],
      "bbox_max": [
        548.800048828125,
        799.7999877929688,
        67.80000305175781
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -548.800048828125,
      "bbox_min": [
        548.5,
        799.7000122070312,
        67.5
      ],
      "bbox_max": [
        548.800048828125,
        799.7999877929688,
        67.80000305175781
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 548.5,
      "bbox_min": [
        548.5,
        799.7000122070312,
        67.5
      ],
      "bbox_max": [
        548.5,
        799.7999877929688,
        67.80000305175781
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -548.6400146484375,
      "bbox_min": [
        548.6400146484375,
        799.7000122070312,
        65.0
      ],
      "bbox_max": [
        548.6400146484375,
        799.7999877929688,
        67.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9241674542427063,
        0.38198786973953247,
        -0.0
      ],
      "plane_d": -783.2644653320312,
      "bbox_min": [
        532.9449462890625,
        750.8700561523438,
        65.0
      ],
      "bbox_max": [
        538.8456420898438,
        761.1082153320312,
        79.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7938141822814941,
        0.6081603765487671,
        -0.0
      ],
      "plane_d": -884.3927001953125,
      "bbox_min": [
        535.2213745117188,
        750.8700561523438,
        65.0
      ],
      "bbox_max": [
        538.8456420898438,
        755.6007080078125,
        79.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 546.313720703125,
      "bbox_min": [
        532.1715698242188,
        799.7999877929688,
        5.0
      ],
      "bbox_max": [
        573.5928344726562,
        827.0,
        80.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -5.0,
      "bbox_min": [
        546.313720703125,
        799.7999877929688,
        5.0
      ],
      "bbox_max": [
        573.5928344726562,
        827.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 557.5,
      "bbox_min": [
        546.313720703125,
        799.7999877929688,
        5.0
      ],
      "bbox_max": [
        557.5,
        818.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8542449474334717,
        -0.4931878447532654,
        -0.16441155970096588
      ],
      "plane_d": 871.035400390625,
      "bbox_min": [
        549.7255859375,
        809.2772216796875,
        5.0
      ],
      "bbox_max": [
        551.177978515625,
        813.3082275390625,
        8.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8542194962501526,
        0.4932328462600708,
        -0.1644088178873062
      ],
      "plane_d": 70.74530029296875,
      "bbox_min": [
        549.7255859375,
        811.2928466796875,
        5.0
      ],
      "bbox_max": [
        551.177978515625,
        813.3082275390625,
        8.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        -0.0
      ],
      "plane_d": 963.998779296875,
      "bbox_min": [
        550.5,
        809.7999877929688,
        8.0
      ],
      "bbox_max": [
        553.5,
        812.7999877929688,
        17.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5547001361846924,
        0.0,
        0.8320503234863281
      ],
      "plane_d": 298.7060241699219,
      "bbox_min": [
        550.5,
        809.7999877929688,
        8.0
      ],
      "bbox_max": [
        552.0,
        812.7999877929688,
        9.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 818.0,
      "bbox_min": [
        546.313720703125,
        799.7999877929688,
        65.0
      ],
      "bbox_max": [
        557.5,
        818.0,
        80.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.8542449474334717,
        -0.4931878447532654,
        -0.16441155970096588
      ],
      "plane_d": 884.0366821289062,
      "bbox_min": [
        551.37255859375,
        812.784423828125,
        65.0
      ],
      "bbox_max": [
        556.02734375,
        816.8154296875,
        68.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8542461395263672,
        -0.4931885004043579,
        -0.1644039750099182
      ],
      "plane_d": -61.9547119140625,
      "bbox_min": [
        551.37255859375,
        812.784423828125,
        65.0
      ],
      "bbox_max": [
        556.02734375,
        816.8154296875,
        68.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8542194962501526,
        0.4932328462600708,
        -0.1644088178873062
      ],
      "plane_d": 80.286865234375,
      "bbox_min": [
        551.37255859375,
        814.800048828125,
        65.0
      ],
      "bbox_max": [
        552.824951171875,
        816.8154296875,
        68.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071195244789124,
        0.7070940732955933,
        -0.0
      ],
      "plane_d": -967.6399536132812,
      "bbox_min": [
        551.9146728515625,
        813.145263671875,
        68.0
      ],
      "bbox_max": [
        555.37939453125,
        816.53955078125,
        77.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": -184.6680908203125,
      "bbox_min": [
        551.9146728515625,
        813.145263671875,
        68.0
      ],
      "bbox_max": [
        555.308837890625,
        816.53955078125,
        77.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -3.7876685382798314e-05,
        -0.5156153440475464,
        0.8568202257156372
      ],
      "plane_d": 361.02740478515625,
      "bbox_min": [
        551.9853515625,
        813.145263671875,
        68.0
      ],
      "bbox_max": [
        555.308837890625,
        814.80712890625,
        69.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5078026056289673,
        -0.01057465560734272,
        0.861408531665802
      ],
      "plane_d": 230.32254028320312,
      "bbox_min": [
        551.9146728515625,
        813.1455078125,
        68.0
      ],
      "bbox_max": [
        553.6470947265625,
        816.53955078125,
        69.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": 184.6680908203125,
      "bbox_min": [
        551.9146728515625,
        813.145263671875,
        68.0
      ],
      "bbox_max": [
        555.37939453125,
        816.53955078125,
        77.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.49991968274116516,
        0.8660718202590942
      ],
      "plane_d": -467.0970764160156,
      "bbox_min": [
        551.9146728515625,
        814.80712890625,
        68.0
      ],
      "bbox_max": [
        555.37939453125,
        816.53955078125,
        69.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.507815420627594,
        -0.010555896908044815,
        0.8614012598991394
      ],
      "plane_d": -331.9862060546875,
      "bbox_min": [
        553.6470947265625,
        813.145263671875,
        68.0
      ],
      "bbox_max": [
        555.37939453125,
        816.53955078125,
        69.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 809.5,
      "bbox_min": [
        548.4000244140625,
        799.7999877929688,
        65.0
      ],
      "bbox_max": [
        548.9000244140625,
        810.0,
        68.19999694824219
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -548.9000244140625,
      "bbox_min": [
        548.4000244140625,
        809.5,
        65.0
      ],
      "bbox_max": [
        548.9000244140625,
        810.0,
        68.19999694824219
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -810.0,
      "bbox_min": [
        548.4000244140625,
        809.5,
        65.0
      ],
      "bbox_max": [
        548.9000244140625,
        810.0,
        68.19999694824219
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 548.4000244140625,
      "bbox_min": [
        548.4000244140625,
        809.5,
        65.0
      ],
      "bbox_max": [
        548.9000244140625,
        810.0,
        68.19999694824219
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -68.19999694824219,
      "bbox_min": [
        548.4000244140625,
        809.5,
        68.19999694824219
      ],
      "bbox_max": [
        548.9000244140625,
        810.0,
        68.19999694824219
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 67.5,
      "bbox_min": [
        548.5,
        799.7999877929688,
        65.0
      ],
      "bbox_max": [
        548.800048828125,
        809.5,
        67.80000305175781
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -67.80000305175781,
      "bbox_min": [
        548.5,
        799.7999877929688,
        67.5
      ],
      "bbox_max": [
        548.800048828125,
        809.5,
        67.80000305175781
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -548.800048828125,
      "bbox_min": [
        548.5,
        799.7999877929688,
        67.5
      ],
      "bbox_max": [
        548.800048828125,
        809.5,
        67.80000305175781
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 548.5,
      "bbox_min": [
        548.5,
        799.7999877929688,
        67.5
      ],
      "bbox_max": [
        548.5,
        809.5,
        67.80000305175781
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -548.6400146484375,
      "bbox_min": [
        548.6400146484375,
        799.7999877929688,
        65.0
      ],
      "bbox_max": [
        548.6400146484375,
        809.5,
        67.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 808.0,
      "bbox_min": [
        532.1715698242188,
        799.7999877929688,
        5.0
      ],
      "bbox_max": [
        546.313720703125,
        827.0,
        80.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -5.0,
      "bbox_min": [
        532.1715698242188,
        808.0,
        5.0
      ],
      "bbox_max": [
        546.313720703125,
        827.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 818.0,
      "bbox_min": [
        532.1715698242188,
        808.0,
        65.0
      ],
      "bbox_max": [
        546.313720703125,
        818.0,
        80.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -65.0,
      "bbox_min": [
        532.1715698242188,
        808.0,
        65.0
      ],
      "bbox_max": [
        546.313720703125,
        818.0,
        65.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -5.0,
      "bbox_min": [
        532.1715698242188,
        799.7999877929688,
        5.0
      ],
      "bbox_max": [
        546.313720703125,
        808.0,
        5.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -680.0,
      "bbox_min": [
        521.5,
        640.0,
        80.0
      ],
      "bbox_max": [
        826.3074951171875,
        818.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 97.99999237060547,
      "bbox_min": [
        755.8271484375,
        640.0,
        98.0
      ],
      "bbox_max": [
        826.3074951171875,
        680.0,
        100.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.7063384652137756,
        0.7078742384910583,
        0.0
      ],
      "plane_d": 80.83029174804688,
      "bbox_min": [
        755.8271484375,
        640.0,
        98.0
      ],
      "bbox_max": [
        784.1422119140625,
        660.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3826822340488434,
        0.9238800406455994,
        0.0
      ],
      "plane_d": -309.68353271484375,
      "bbox_min": [
        770.0000610351562,
        654.1421508789062,
        98.0
      ],
      "bbox_max": [
        784.1422119140625,
        660.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 84.0,
      "bbox_min": [
        521.5,
        705.0,
        80.0
      ],
      "bbox_max": [
        595.0,
        818.0,
        95.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 95.0,
      "bbox_min": [
        554.1448364257812,
        705.0,
        84.0
      ],
      "bbox_max": [
        595.0,
        745.5708618164062,
        95.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": 111.92391967773438,
      "bbox_min": [
        554.1448364257812,
        705.0,
        84.0
      ],
      "bbox_max": [
        595.0,
        745.5708618164062,
        95.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.24342486262321472,
        -0.24342486262321472,
        -0.9388762712478638
      ],
      "plane_d": 123.02920532226562,
      "bbox_min": [
        554.1448364257812,
        724.0,
        84.0
      ],
      "bbox_max": [
        575.7156982421875,
        745.5708618164062,
        90.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": -911.966796875,
      "bbox_min": [
        554.1448364257812,
        724.0,
        84.0
      ],
      "bbox_max": [
        575.7156982421875,
        745.5708618164062,
        90.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        -0.7071067690849304,
        0.0
      ],
      "plane_d": 926.1088256835938,
      "bbox_min": [
        564.1448364257812,
        734.0,
        84.0
      ],
      "bbox_max": [
        575.7156982421875,
        745.5708618164062,
        90.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": 933.3810424804688,
      "bbox_min": [
        560.8578491210938,
        705.0,
        84.0
      ],
      "bbox_max": [
        595.0,
        739.1421508789062,
        95.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": -905.0967407226562,
      "bbox_min": [
        560.8578491210938,
        705.0,
        84.0
      ],
      "bbox_max": [
        575.0,
        719.1421508789062,
        95.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 818.0,
      "bbox_min": [
        521.5,
        705.0,
        80.0
      ],
      "bbox_max": [
        595.0,
        818.0,
        84.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -792.0,
      "bbox_min": [
        521.5,
        705.0,
        80.0
      ],
      "bbox_max": [
        595.0,
        818.0,
        84.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": -911.966796875,
      "bbox_min": [
        546.4309692382812,
        705.0,
        80.0
      ],
      "bbox_max": [
        595.0,
        753.2847290039062,
        84.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": -905.0967407226562,
      "bbox_min": [
        560.8578491210938,
        705.0,
        80.0
      ],
      "bbox_max": [
        575.0,
        724.0,
        84.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": 111.92391967773438,
      "bbox_min": [
        560.8578491210938,
        719.1421508789062,
        80.0
      ],
      "bbox_max": [
        565.7156982421875,
        724.0,
        84.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        -0.7071067690849304,
        0.0
      ],
      "plane_d": 926.1088256835938,
      "bbox_min": [
        546.4309692382812,
        725.0,
        80.0
      ],
      "bbox_max": [
        595.0,
        753.2847290039062,
        84.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": 111.92391967773438,
      "bbox_min": [
        575.7156982421875,
        734.0,
        80.0
      ],
      "bbox_max": [
        580.8578491210938,
        739.1421508789062,
        84.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.24342486262321472,
        -0.24342486262321472,
        -0.9388762712478638
      ],
      "plane_d": 123.02920532226562,
      "bbox_min": [
        546.4309692382812,
        735.5708618164062,
        80.0
      ],
      "bbox_max": [
        564.1448364257812,
        753.2847290039062,
        84.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -521.5,
      "bbox_min": [
        521.5,
        792.0,
        80.0
      ],
      "bbox_max": [
        557.5,
        818.0,
        84.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 557.5,
      "bbox_min": [
        557.5,
        792.0,
        80.0
      ],
      "bbox_max": [
        557.5,
        818.0,
        84.0
      ],
      "face_count": 1
    }
  ],
  "placed_objects": [
    {
      "tag": "CGameArea piece: nrx01",
      "entity_class": "CGameArea",
      "piece_name": "nrx01",
      "offset": 54,
      "centroid": [
        554.9791717529297,
        766.4499969482422,
        56.0
      ],
      "bbox_min": [
        532.1715698242188,
        724.0,
        27.0
      ],
      "bbox_max": [
        575.7156982421875,
        808.0,
        90.0
      ],
      "dimensions_source": {
        "span_x": 43.54412841796875,
        "span_y": 84.0,
        "height_z": 63.0,
        "door_width": 84.0,
        "door_depth": 43.54412841796875,
        "leaf_depth": 43.54412841796875,
        "clearance_margin": 0.0,
        "slide_axis": "z",
        "slide_vector": [
          0.0,
          -0.0,
          1.0
        ]
      },
      "vertices": [
        [
          546.313720703125,
          808.0,
          27.0
        ],
        [
          546.313720703125,
          799.7999877929688,
          27.0
        ],
        [
          532.1715698242188,
          799.7999877929688,
          27.0
        ],
        [
          532.1715698242188,
          808.0,
          27.0
        ],
        [
          565.7156982421875,
          724.0,
          90.0
        ],
        [
          565.7156982421875,
          724.0,
          80.0
        ],
        [
          575.7156982421875,
          734.0,
          80.0
        ],
        [
          575.7156982421875,
          734.0,
          90.0
        ]
      ],
      "plane_distance": -27.0
    }
  ],
  "tutorial_messages": []
}